import { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";

import styled from "styled-components/macro";

import FnrLoadingBricks from "UI/FnrLoadingBricks";

import useEffectOnce from "Utilities/Hooks/useEffectOnce";
import useOnce from "Utilities/Hooks/useOnce";

import API from "./API";
import ErrorBoundaryFallback from "./ErrorBoundaryFallback";
import FamilyRegistrationAdminPanelView from "./FamilyRegistrationAdminPanelView";
import { FamilyRegistrationProvider } from "./FamilyRegistrationContext";
import { useFamilyRegistrationContext } from "./FamilyRegistrationContext";

function FamilyRegistration() {
  const [loading, setLoading] = useState(false);

  const {
    state: { familyRegistrationSettings },
    setState,
  } = useFamilyRegistrationContext();

  useEffectOnce(() => {
    if (familyRegistrationSettings || loading) return;

    setLoading(true);
    const getAdminSettings = API.getAdminSettings();
    getAdminSettings
      .post()
      .then((resp) => {
        setLoading(false);
        // resp.familyRegistrationIsLive = true;
        setState(resp);
      })
      .catch((err) => console.log({ err }));
  });

  return (
    <>
      {loading ? (
        <Loading>
          <FnrLoadingBricks show size={52} />
        </Loading>
      ) : (
        <FamilyRegistrationAdminPanelView />
      )}
    </>
  );
}

const Loading = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function FamilyRegistrationWithProviderAndErrorBoundary(props) {
  return (
    <FamilyRegistrationProvider>
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <FamilyRegistration {...props} />
      </ErrorBoundary>
    </FamilyRegistrationProvider>
  );
}
